import * as React from "react";
import { useEffect } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import MenuIcon from "@mui/icons-material/DensityMedium";

const MobileViewNavBar = (props) => {
  const { onDrawerToggle } = props;
  return (
    <AppBar
      sx={{
        bgcolor: "black",
        border: "2px solid black",
        p: 0,
        width: "100%",
        height: "80px",
      }}
      position="fixed"
    >
      <Toolbar>
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignContent: "center",
          }}
        >
          <Box
            component="div"
            wordWrap="break-word !important"
            width={"20%"}
            lineHeight={"1.37"}
            sx={{ py: 2 }}
          >
            <Typography
              variant="h2"
              gutterBottom
              color="white"
            >
              Fresh Artists
            </Typography>
          </Box>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={onDrawerToggle}
            edge="start"
          >
            <MenuIcon />
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
  );
};
export { MobileViewNavBar };
